import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from './types';
import { OddDTO } from '@supersports/services';

interface Forecast {
  isOpen: boolean;
  isOpenSum: boolean;
  match: OddDTO;
}

const initialState = { isOpen: false, isOpenSum: false } as Forecast;

export const forecastSlice = createSlice({
  name: 'forecast',
  initialState,
  reducers: {
    setOpenModal: (state, action) => {
      Object.assign(state, action.payload);
    },

    setOpenSumModal: (state, action) => {
      state.isOpenSum = action.payload;
    },
  },
});

export const { setOpenModal, setOpenSumModal } = forecastSlice.actions;

export const selectForecastState = (state: RootState) => state.forecast;

export default forecastSlice.reducer;
